import {createStyles, Group, Modal, Stack, Text} from '@mantine/core';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface SchemaFieldValueErrorsModalProps {
  opened: boolean;
  onClose: () => void;
  errorLabel: string;
  messages: Array<string>;
}

const useStyles = createStyles((theme) => ({
  errorIcon: {
    color: theme.colors.red[6],
    // Nudge the icon down so it aligns with the first line of the message text.
    marginTop: theme.spacing.xs,
  },
}));

/**
 * Modal that lists every error message for a single field's error label. Shown when a field has more than
 * one error of the same label (e.g. a field failing multiple configurable validation rules), which the
 * field's help popover cannot display legibly on its own.
 */
export default function SchemaFieldValueErrorsModal({
  opened,
  onClose,
  errorLabel,
  messages,
}: SchemaFieldValueErrorsModalProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Validation errors"
      size="md"
      {...getTestProps({component: 'SchemaFieldValueErrorsModal', element: 'root'})}
    >
      <Stack spacing="sm">
        <Text size="sm">This field has multiple “{errorLabel}” errors:</Text>
        <Stack spacing="xs">
          {messages.map((message, index) => (
            <Group key={`${index}-${message}`} spacing="xs" align="flex-start" noWrap={true}>
              <BenchlingIcon icon="circle-xmark" className={classes.errorIcon} />
              <Text size="sm">{message}</Text>
            </Group>
          ))}
        </Stack>
      </Stack>
    </Modal>
  );
}
